var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.809 -270.752)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#efefef",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(134.809 270.752)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#424e55",
    d: "M144.429,283.752h-1.1l.35-2.38h-1.225l-.349,2.38h-1.091l.346-2.38h-1.138V280.3h1.3l.213-1.444h-1.2v-1.077h1.354l.349-2.37h1.094l-.349,2.37h1.224l.35-2.37h1.1l-.349,2.37h1.044v1.077h-1.2l-.212,1.444h1.077v1.077h-1.235Zm-1.811-3.457h1.224l.213-1.444h-1.224Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberSign);
export default __webpack_public_path__ + "static/media/number_sign.ff3bf9daa5fa79d6987f85da517eaab8.svg";
export { ForwardRef as ReactComponent };